<template>
  <div style="position: relative;" >
    <b-row  >
      <b-col>
        <b-img
            v-bind="mainProps"
            @click="handleProductClick"
            fluid
            :src="faveData.imgURL"
            style="object-fit: scale-down; margin:15px;cursor:pointer"
            alt="Image 2"
        />
      </b-col>
    </b-row>
    <b-row v-if="false" style="margin-bottom: 15px;">
      <b-col>
        <p>{{faveData.name}}</p>
      </b-col>
    </b-row>
    <b-row style="position: absolute; bottom: 0;">
      <b-col>
        <b-button
            style="background-color: #fe818b; border: none"
            block
            @click="handleGetClick"
        >
          GET
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>


<script>
export default {
  name: "Faves_Product",
  components: {},
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    faveEntity: {
      type: Object,
      default: () => {}
    }
  },
  computed: {

  },
  created() {},
  mounted() {},
  methods: {
    handleProductClick(){
      if (this.faveEntity && this.faveEntity.slug) {
        this.$router.push(`/faves/${this.faveEntity.slug}`);
      }
    },
    handleGetClick(){
      if (this.getURL) {
        window.open(this.getURL, "_blank");
      }
    }
  },
  data() {
    return {
      mainProps: { blank: false, blankColor: '#777', width: 200, height: 200, class: 'm1' },
      faveData: this.faveEntity && this.faveEntity.form ? this.faveEntity.form : null,
      getURL: this.faveEntity && this.faveEntity.form && this.faveEntity.form.url ?
          this.faveEntity.form.url: null
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
</style>